<script>
  import {mapActions, mapGetters} from 'vuex'
  import Form from './components/Form.vue'
  import Sidebar from './components/Sidebar.vue'
  import ThankyouPage from './components/ThankyouPage.vue'

  export default {
    name: 'app',

    components: {
      Form,
      Sidebar,
      ThankyouPage
    },

    computed: {
      ...mapGetters(['isCompleted', 'isUiLoaded'])
    },

    methods: {
      ...mapActions(['initForm', 'setHospitalInfo','completeStep'])
    },

    created: function () {
      let ctx = this;
      this.initForm(this).then(response => {
        // this work only if there is only one hospital choices available and the selector is disabled (for example madonnina)
        console.log(ctx.$config.hospitalID);
        if (!ctx.$config.enableHospitalsChoice) {
          ctx.setHospitalInfo({vm: ctx, hospitalId: ctx.$config.hospitalID}).then(response => {
            ctx.completeStep(0);
          })
        } else if (ctx.$config.hospitalID) {
          ctx.setHospitalInfo({vm: ctx, hospitalId: ctx.$config.hospitalID}).then(response => {
            ctx.completeStep(0);
          })
        }
      });
    }
  }
</script>

<template>
  <div id="booking-app" class="row" :class="{ loading : !isUiLoaded }">

    <Form v-if="!isCompleted && isUiLoaded"/>

    <Sidebar v-if="!isCompleted && isUiLoaded"/>

    <ThankyouPage v-if="isCompleted && isUiLoaded"/>

  </div>
</template>
